import { withStyles } from '@material-ui/core/styles';

const formStyles = theme => ({
    root: {
        width: '100%',
    },
    button: {
        margin: theme.spacing(),
    },
    formInput: {
        marginLeft: theme.spacing(),
    },
    formInputError: {
        display: 'inline-flex',
        color: '#f00',
        fontSize: 12,
        marginBottom: theme.spacing(),
    },
    masterPasswordForm: {
        width: '80%',
    },
    excludeSitesInputs: {},
    excludeSitesActions: {},
    excludeSitesLine: {
        position: 'relative',
        marginBottom: theme.spacing(2),
        '& .row': {
            width: '80%',
        },
    },
    booleanMap: {
        margin: theme.spacing(3),
    },
});

const policyStyles = theme => ({
    columnName: {
        flexBasis: '40%',
        display: 'flex',
    },

    columnDetail: {
        flexBasis: '60%',
        display: 'flex',
    },
    expandIcon: {
        alignSelf: 'flex-start',
    },

    content: {
        margin: '12px 0 !important',
    },

    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    secondaryHeading: {
        paddingLeft: theme.spacing(),
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
        whiteSpace: 'no-wrap',
        overflow: 'hidden',
        width: 380,
        textOverflow: 'ellipsis',
    },
    additionalInfo: {
        paddingLeft: theme.spacing(),
    },
    info: {
        display: 'flex',
    },
    help: {
        paddingLeft: theme.spacing(),
        color: theme.palette.text.secondary,
    },

    tooltip: {
        fontSize: theme.typography.pxToRem(13),
    },
});

const modalStyles = theme => ({
    paper: {
        position: 'relative',
        width: theme.spacing(50),
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
    },

    privateKey: {
        display: 'inline-block',
        wordBreak: 'break-all',
        border: '1px solid',
        fontFamily: 'Roboto',
        fontSize: '13px',
        borderColor: theme.palette.background.default,
    },
    dialog: {
        maxWidth: 760,
        minHeight: 300,
    },
    dialogFixed: {
        height: 300,
    },
    dialogPrivateKey: {
        height: 600,
    },
});

export const withFormStyles = component => withStyles(formStyles)(component);

export const withModalStyles = component => withStyles(modalStyles)(component);

export const withPolicyStyles = component =>
    withStyles(policyStyles)(component);
